import styled from 'styled-components';
import { Typography } from '../../../UiLibrary';

export const OriginalPrice = styled(Typography.Text)`
    text-decoration: line-through;
`;
